export const fadeOnScroll = () => {

	//Elements to fade in.
	let elsToFade = [
		'.m__hero__overlay-inner',
		'.m__promo__content-wrapper',
		'.m__llist__filter',
		'.m__coimg__overlay-content',
		'.m__cslider__top',
		'.m__cslider__swiper',
		'.m__pslider__swiper',
		'.m__cpromos__header',
		'.m__cpromos__wrapper',
		'.m__iwcard__media',
		'.m__iwcard__card',
		'.m__spaces-feed__search',
		'.m__spaces-feed__grid',
		'.m__banner__inner',
		'.m__wysiwyg .u__wrap',
		'.m__mwcaption__cols',
		'.m__islider__swiper',
		'.m__vplayer__player',
		'.m__fuse-feed__search',
		'.m__fuse-feed__grid',
		'.m__opening-times__inner',
		'.m__map__content'

	];
	//Check for all instances of that element on the page
	let elementsToFade = [];
	let allElementsFound = [];
	elsToFade.forEach((el) => {
		allElementsFound = [].slice.call(document.querySelectorAll(el))
		elementsToFade 	 = elementsToFade.concat(allElementsFound);
	})


	//Make sure we can use intersection observer
	if ("IntersectionObserver" in window) {

		//First set all elements to be faded out on page load
		elementsToFade.forEach((el) => {
			el.classList.add('to-fade');
		});


		//Create an observer to add the fade in class
		var lazyFadeObserver;
		lazyFadeObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(fadeEl) {
				if (fadeEl.isIntersecting) {

					//Add the fade in class
					setTimeout(() => {
						fadeEl.target.classList.add('fade-in');
					},250);
					
					
					//Remove this map from the observer, as it's now loaded in
					lazyFadeObserver.unobserve(fadeEl.target);
				}
			});
		},{
			threshold: 0.1,
		});

		//Add the fade elements to the observer
		if(lazyFadeObserver){
			elementsToFade.forEach((el) => {
				lazyFadeObserver.observe(el);
			})
		}
	}
}